<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <div class="min-h-screen bg-canvas flex items-center justify-center px-4">
    <main class="w-full max-w-md">
      <RouterView />
    </main>
  </div>
</template>
